import { GHLLanguageKeys as o } from "./ghl-ui.es285.js";
import e from "./ghl-ui.es1275.js";
const f = {
  name: o.finnish,
  locale: e
};
export {
  f as date_fi
};
